const CLEAR_DASHBOARD_DATA = 'clear-dashboard-data';
const SAVE_DISPOSITION_AND_CLEAR_DASHBOARD_DATA = 'save-disposition-and-clear-dashboard-data';

export default {
  CLEAR_DASHBOARD_DATA,
  SAVE_DISPOSITION_AND_CLEAR_DASHBOARD_DATA,
};
